'use strict';

const docsUrl = (ruleName) => {
  return `https://github.com/jaem1n207/eslint-plugin-ben/blob/HEAD/docs/rules/${ruleName}.md`;
};

module.exports = docsUrl;
